<template>
  <div class="Pop_bottom">
    <!--<p class="Pop_bottom_p">为你推荐更多</p>-->
    <div class="Pop_bottom_div">
      <p
        style="
              font-size: 0.22rem;
              color: #8e8e93;
              margin-top: 0.24rem;
              margin-left: 0.24rem;
            "
      >
        赛事·和平精英
      </p>
      <p
        style="
              font-size: 0.28rem;
              font-weight: 700;
              margin-top: 0.16rem;
              margin-left: 0.24rem;
              display: inline-flex;
              align-content: flex-start;
              flex-direction: row;
              justify-content: center;
              align-items: center;
            "
      >
        加群参与和平社群赛，赢大奖
        <img
          style="width: 0.24rem; height: 0.24rem"
          src="https://game.gtimg.cn/images/tgclub/act/a20221230sscg/20230103101020.png"
        />
      </p>
      <div class="add_group">
        <ul class="add_group_ul">
          <li>加群<br />即得</li>
            <li>
              <template v-for="(item, index) in giftList">
                <img
                  :src="item.iconImage"
                  :key="`img${index}`"
                />
                <span :key="`name${index}`">{{ item.name }}</span>
                <span :key="`blank${index}`" v-if="giftList.length - 1 != index">或</span>
              </template>
            </li>

        </ul>
        <ul class="add_group_ul2">
          <li>
            <img
              src="https://game.gtimg.cn/images/tgclub/act/a20221230sscg/Vector.png"
            />
            <span @click="joinQQGroupFunc">加入QQ群</span>
          </li>
          <li>
            <img
              style="width: 0.24rem; height: 0.24rem"
              src="https://game.gtimg.cn/images/tgclub/act/a20221230sscg/20230105095538.png"
            />
            <span style="color: #02ca72" @click="joinWxGroupFunc">加入微信群</span>
          </li>
        </ul>
        <img
          style="
                width: 1.8rem;
                height: 2rem;
                position: relative;
                top: -3rem;
                left: 4.75rem;
              "
          src="https://game.gtimg.cn/images/tgclub/act/a20221230sscg/image269.png"
        />
      </div>
    </div>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin } from '@tencent/ceiba-base-components';

export default {
  name: 'CTgclubCompetitionJoinGroup',
  components: {},
  mixins: [componentBaseMixin],
  props: {
    qqGroupLink: {
      type: String,
      default: '',
    },
    queryGroupListEnv: {
      type: String,
      default: 'prod',
    },
    competitionId: {
      type: String,
      default: '',
    },
    gid: {
      type: Number,
      default: 0,
    },
    giftList: {
      type: Array,
      default: () => ([
        { iconImage: 'https://game.gtimg.cn/images/tgclub/act/a20221230sscg/Image.png', name: '1-88 Q币' },
        { iconImage: 'https://game.gtimg.cn/images/tgclub/act/a20221230sscg/97.png', name: '1-88 Q币' },
      ]),
    },
  },
  data() {
    return {
      cssPrefix: 'tgclub-competition-join-group-',
      joinWxGroupLink: '', // 微信群链接
    };
  },
  computed: {},
  mounted() {
    this.initialize();
  },
  methods: {
    initialize() {
      if (this.isLogin) this.queryGroupQrCodeList();
    },
    async doSleep(time) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve();
        }, time);
      });
    },
    async joinQQGroupFunc() {
      if (this.qqGroupLink) {
        this.reportFunc('open_url', { url: this.qqGroupLink });
        this.reportFlush();
        await  this.doSleep(500);
        this.$ast.openView({ url: this.qqGroupLink });
      }
    },
    async joinWxGroupFunc() {
      if (!this.isLogin) {
        this.$alert({ msg: '请先登录' });
        return false;
      }
      if (this.joinWxGroupLink) {
        this.reportFunc('open_url', { url: this.joinWxGroupLink });
        this.reportFlush();
        await  this.doSleep(500);
        this.$ast.openView({ url: this.joinWxGroupLink });
      } else {
        console.warn('this.joinWxGroupLink is empty and can not be access');
      }
    },
    async queryGroupQrCodeList() {
      let url = '';
      if (this.queryGroupListEnv === 'prod') {
        url = 'https://bgw.xinyue.qq.com/xyapp.CompetitionSrv/GetChatUrlList';
      } else {
        url = 'https://bgw-t.xinyue.qq.com/xyapp.CompetitionSrv/GetChatUrlList';
      }
      const response = await this.$requestInstance.post(url, { gid: this.gid, competition_id: this.competitionId });
      console.log('queryGroupQrCodeList response =',  response);
      const { ret, msg, data = {} } = response;
      if (ret !== 0) {
        return this.$alert({ msg: msg || '获取微信二维码失败' });
      }
      const { list = [] } = data;
      if (!list || list.length === 0) {
        return this.$alert({ msg: '获取微信二维码失败!' });
      }
      this.joinWxGroupLink = list[0]?.url  ?? '';
    },
    reportFunc(key, obj) {
      if (typeof  this.reportClickRaw === 'function') {
        const params = {
          ceibaComponentId: `${this.cid}`,
          ceibaComponentUid: this.uid,
          ceibaComponentUname: this.uname,
          eventKey: key,
          eventData: obj,
        };
        this.reportClickRaw(params);
        console.log('reportFunc sign_up data =', params);
      }
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
.Pop_bottom {
  width: 7.5rem;
  height: 4.64rem;
  /* background: red; */
  overflow: hidden;
}
.Pop_bottom_p {
  font-size: 0.32rem;
  font-weight: 700;
  margin-left: 0.32rem;
  margin-top: 0.32rem;
}
.Pop_bottom .Pop_bottom_div {
  width: 6.86rem;
  height: 3.28rem;
  background: linear-gradient(0deg, #f7f9fa, #f7f9fa),
  linear-gradient(180deg, #bee4ff 0%, #f4fbff 68.96%);

  border-radius: 0.16rem;
  margin-left: 0.32rem;
  margin-top: 0.24rem;
  overflow: hidden;
}
.add_group {
  width: 4.7rem;
  height: 0.8rem;
  background: linear-gradient(
      180deg,
      #ffffff 100%,
      rgba(255, 255, 255, 0) 100%
  );
  border: 0.02rem solid #ffffff;
  border-radius: 0.12rem;
  background: url(https://game.gtimg.cn/images/tgclub/act/a20221230sscg/Rectangle.png);
  background-size: 1.04rem 0.8rem;
  background-repeat: no-repeat;
  margin-top: 0.24rem;
  margin-left: 0.24rem;
}
.add_group_ul {
  width: 4.5rem;
  height: 0.8rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-left: 0.15rem;
}
.add_group_ul li:nth-child(1) {
  font-size: 0.22rem;
  background: linear-gradient(180deg, #e3bc8a 0%, #d3a05f 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
}
.add_group_ul li:nth-child(2),
.add_group_ul li:nth-child(3) {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.2rem;
  color: #8e8e93;
}
.add_group_ul li:nth-child(2) img {
  width: 0.6rem;
  height: 0.6rem;
  margin-right: 0.08rem;
  margin-left: 0.08rem;
}
.add_group_ul2 {
  display: flex;
  justify-content: space-between;
  width: 6.38rem;
}
.add_group_ul2 li {
  text-align: center;
  /* line-height: 0.64rem; */
  width: 3.11rem;
  height: 0.64rem;
  flex-basis:  3.11rem;;
  background: #ffffff;
  border-radius: 0.12rem;
  font-size: 0.24rem;
  color: #12b7f5;
  margin-top: 0.24rem;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  align-items: center;
  justify-content: space-evenly;

}
.add_group_ul2 li img {
  width: 0.2rem;
  height: 0.24rem;
}
</style>
